import * as React from "react";
import { useUser } from "../user/useUser";
import { BlockItem } from "./BlockItem";
import { useMenu } from "./useMenu";

type Props = {
  onClickOnAnyLink: () => void;
  onChildOpen: (isOpen: boolean) => void;
};

export function DDProBlock({ onClickOnAnyLink, onChildOpen }: Props) {
  const [{ children }] = useMenu().items.all;
  const [item] = children;
  const { clinicName, isPro } = useUser();

  return isPro ? (
    <ul aria-label="DD PRO" className="elm-p-0 elm-my-2">
      <BlockItem
        categoryButtonChildren={
          <div className="elm-flex-grow elm-flex elm-flex-col elm-text-center elm-pointer-events-none">
            <span className="elm-text-dd-green-900 elm-text-sm">DD PRO</span>
            <span className="elm-text-dd-gray-900 elm-text-xl">{clinicName}</span>
          </div>
        }
        className="elm-transition elm-bg-dd-green-100 elm-h-20 md:elm-h-24 elm-flex elm-rounded-xl lg:hover:elm-bg-dd-green-200 lg:hover:elm-text-dd-gray-500"
        label={clinicName}
        onClickOnAnyLink={onClickOnAnyLink}
        onChildOpen={onChildOpen}
        children={item.children}
      />
    </ul>
  ) : (
    <ul className="elm-p-0 elm-my-2" />
  );
}
